export const caseValidations = {
  description: {
    required: true,
    minLength: 50,
    maxLength: 500,
  },
  budget: {
    required: true,
  },
};
